import { ProgressBarPoint } from "common/contracts";

export function convertProgressBarPointsToApiFormat(progressBarPoints: any): ProgressBarPoint[] | undefined {
    if (progressBarPoints.progressBarId && progressBarPoints.progressBarPoints) {
        return [
            {
                points: progressBarPoints.progressBarPoints,
                barId: progressBarPoints.progressBarId
            }
        ]
    }
    return undefined;
}
